import { useCallback, useState, useMemo } from 'react';
import { Button } from '@Sage/hoi-poi-ui';

import VideoModal from 'components/VideoModal';
import { getLiteral } from 'utils/getLiteral';
import { logEvent } from 'utils/tracking';

import './styles.scss';
import { isEmpty } from '../../utils/isEmpty';

const AutomationsHelpActions = (props) => {
    const {
        className,
        extraActions = [],
        trackingEvent = 'settings',
        knowledgeMoreLabel = getLiteral('action_automations_knowledge_base'),
        knowledgeMoreUrl = getLiteral('label_automations_knowledge_base_all_links'),
        videoTutorialLabel = getLiteral('action_automations_video_tutorial_intro'),
        videoTutorialUrl = getLiteral('label_automations_video_tutorial_intro_link'),
    } = props;

    const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);

    const openVideoTutorial = useCallback(() => {
        setIsVideoModalOpen(true);
        logEvent({
            event: trackingEvent,
            functionality: 'openVideoTutorial',
            submodule: 'automationsTemplate',
        });
    }, [trackingEvent]);

    const closeVideoModal = useCallback(() => {
        setIsVideoModalOpen(false);
    }, []);

    const openKnowledgeBase = useCallback(() => {
        if (isEmpty(knowledgeMoreUrl)) return;

        window.open(knowledgeMoreUrl, '_blank');
        logEvent({
            event: trackingEvent,
            functionality: 'openKnowledgeBase',
            submodule: 'automationsTemplate',
        });
    }, [trackingEvent, knowledgeMoreUrl]);

    const helpActions = useMemo(() => {
        return [
            {
                icon: 'playCircleFilled',
                label: videoTutorialLabel,
                onClick: openVideoTutorial,
            },
            {
                icon: 'helpOutline',
                label: knowledgeMoreLabel,
                onClick: openKnowledgeBase,
            },
            ...extraActions,
        ];
    }, [
        extraActions,
        knowledgeMoreLabel,
        openKnowledgeBase,
        openVideoTutorial,
        videoTutorialLabel,
    ]);

    return (
        <>
            <div className={className || 'fm-automations-help-actions'}>
                {helpActions.map(({ icon, label, onClick }, index) => (
                    <Button icon={icon} key={index} onClick={onClick} size="small" type="terciary">
                        {label}
                    </Button>
                ))}
            </div>
            <VideoModal
                isOpen={isVideoModalOpen}
                onRequestClose={closeVideoModal}
                title={videoTutorialLabel}
                videoUrl={videoTutorialUrl}
            />
        </>
    );
};

AutomationsHelpActions.displayName = 'AutomationsHelpActions';

export default AutomationsHelpActions;
